
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{staticClass:"i-fill",attrs:{"cx":"22.781","cy":"24.89","fill":"#D0EFEC","rx":"17","ry":"15"}}),_c('path',{staticClass:"i-Union",attrs:{"stroke":"#234652","d":"m39.699 14.784.132.19.23.023 3.32.32 1.108 5.896-1.936.979-.28.141.006.314.002.243c0 4.629-2.292 8.797-5.954 11.647l-.16.124-.028.2-.918 6.53h-5.88l-.408-2.9-.073-.517-.513.094a20 20 0 0 1-3.566.322c-1.223 0-2.416-.11-3.567-.322l-.512-.094-.073.516-.408 2.9h-5.88l-.919-6.528-.028-.2-.16-.125c-3.661-2.85-5.953-7.018-5.953-11.647 0-8.506 7.778-15.5 17.5-15.5 1.714 0 3.37.219 4.934.625l.147.038.143-.05 4.129-1.43 1.367 3.95.053.152.131.093a16.4 16.4 0 0 1 4.014 4.016Z"}}),_c('path',{staticClass:"i-Ellipse 38",attrs:{"stroke":"#234652","d":"M18.28 11.094a17.9 17.9 0 0 1 6.5-1.204c2.123 0 4.148.362 6 1.018"}}),_c('path',{staticClass:"i-Line 38",attrs:{"stroke":"#234652","d":"m36.738 14.325-.708.705"}}),_c('path',{staticClass:"i-Vector 134",attrs:{"stroke":"#234652","d":"M9.704 15.271c-1.425.178-4.296-.28-3.94-3.361.356-3.08 3.45-2.916 3.673-1.514.223 1.403-2.988 4.96-5.298 2.65-1.825-1.826-.542-4.379.4-5.076"}})])
          )
        }
      }
    